import { render, staticRenderFns } from "./BoothInfo.vue?vue&type=template&id=15e9054a"
import script from "./BoothInfo.vue?vue&type=script&lang=ts"
export * from "./BoothInfo.vue?vue&type=script&lang=ts"
import style0 from "./BoothInfo.vue?vue&type=style&index=0&id=15e9054a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports